import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolsService } from '../../tools/tools.service';
import { FullePointOfSaleService } from '../../api/fulle/fulle-pointOfSale/fulle-pointOfSale.service';

@Injectable({
  providedIn: 'root'
})
export class ClientMerchantsService {

  constructor(
    private baseClient: BaseclientService,
    private posApi: FullePointOfSaleService,
    private tools: ToolsService
  ) { }

  getClientMerchants(): Observable<any> {
    return from(this.baseClient.getBase("getClientMerchants")).pipe(
      map(data => {

        data.merchants.map((merchant: any) => {


          merchant.points_of_sale.map((pos: any) => {
            let currBanner = this.posApi.banners.filter(banner => banner.activity === merchant.activity);
            pos.banner_original = "assets/img/banners/" + currBanner[0].banner + ".jpg";
          });


      


        });

        return data.merchants;

      })
    );
  }

  // getMerchantClient(merchantId: number|any, merchantKey?: any): Observable<any> {
  //   const params = merchantId ? { merchant_id: merchantId } : { merchant_key: merchantKey };
  
   
  //   return from(this.baseClient.postBase("getMerchantClient", params)).pipe(
  //     map(data => {
  //       return data.client_merchant != null ? data.client_merchant : {};
  //     })
  //   );
  // }

  
  getMerchantClient(merchantId?: number|any): Observable<any> {

    let params:any = merchantId ? { merchant_id: merchantId } : {};
    
    params['id_merchant'] = this.tools.getStor("id_merchant")
   
    return from(this.baseClient.postBase("getMerchantClient_", params)).pipe(
      map(data => {
        return data.client_merchant != null ? data.client_merchant : {};
      })
    );
  }

  getMerchant(merchantId: number): Observable<any> {
    const params = { merchant_id: merchantId };
  
    return from(this.baseClient.postBase("getMerchant", params)).pipe(
      map(data => {
          
        return data.merchant;
      })
    );
  }

  getClientMerchantsOptions(): Observable<any> {
    return from(this.baseClient.getBase("getClientMerchantsOptions")).pipe(
      map(data => {
        return data.client_merchants_options;
      })
    );
  }




}
